import { IInspectorStore } from './types';
import { EInspectorActions } from './actions';
import { IStore } from 'redux/store';
import { jobSelectors } from 'redux/_core/job';

const inspectorSelectors = {
    _getStore(store: IStore) {
        return store.app.vesselStore.inspector;
    },
    getDateRange(inspectorStore: IInspectorStore) {
        return inspectorStore.filters.dateRange;
    },
    getEntryFilter(inspectorStore: IInspectorStore) {
        return inspectorStore.filters.entry;
    },
    getSelectedLog(inspectorStore: IInspectorStore) {
        return inspectorStore.selectedLog;
    },
    getSelectedLogId(inspectorStore: IInspectorStore) {
        return inspectorStore.selectedLog.selectedLogId;
    },
    getStateOfScriptInjection(inspectorStore: IInspectorStore) {
        return inspectorStore.stateOfScriptInjection;
    },
    getLogs(inspectorStore: IInspectorStore) {
        return inspectorStore.logs;
    },
    getSealLogs(inspectorStore: IInspectorStore) {
        return inspectorStore.sealLogs;
    },
    getPagination(inspectorStore: IInspectorStore) {
        return inspectorStore.pagination;
    },
    getIndexOfTasks(inspectorStore: IInspectorStore) {
        return inspectorStore.indexOfTasks;
    },
    getBooks(inspectorStore: IInspectorStore) {
        return inspectorStore.books;
    },
    getFilteredBy(inspectorStore: IInspectorStore) {
        return inspectorStore.filteredBy;
    },
    getSearchBy(inspectorStore: IInspectorStore) {
        return inspectorStore.searchBy;
    },
    getShowCoverPages(inspectorStore: IInspectorStore) {
        return inspectorStore.showCoverPages;
    },
    jobToLoadAllLogsOfADay(inspectorStore: IInspectorStore) {
        return jobSelectors.getJobStatus(
            inspectorStore,
            EInspectorActions.GET_ALL_LOGS_OF_A_DAY
        );
    },
    jobToLoadAssociatedDayLog(inspectorStore: IInspectorStore) {
        return jobSelectors.getJobStatus(
            inspectorStore,
            EInspectorActions.GET_DAY_LOG_PARTICULAR_DATE
        );
    },
    jobToGetLogs(inspectorStore: IInspectorStore) {
        return jobSelectors.getJobStatus(
            inspectorStore,
            EInspectorActions.GET_LOGS
        );
    },
    jobToGetSealLogs(inspectorStore: IInspectorStore) {
        return jobSelectors.getJobStatus(
            inspectorStore,
            EInspectorActions.GET_SEAL_LOGS
        );
    },
    jobToGetLogConfig(inspectorStore: IInspectorStore) {
        return jobSelectors.getJobStatus(
            inspectorStore,
            EInspectorActions.GET_LOG_CONFIG
        );
    },
    jobToGetLogsCount(inspectorStore: IInspectorStore) {
        return jobSelectors.getJobStatus(
            inspectorStore,
            EInspectorActions.GET_LOGS_COUNT
        );
    },
    jobToGetLogPrintTemplate(inspectorStore: IInspectorStore) {
        return jobSelectors.getJobStatus(
            inspectorStore,
            EInspectorActions.GET_LOG_PRINT_TEMPLATE
        );
    },
    jobToGetIndexOfTasks(inspectorStore: IInspectorStore) {
        return jobSelectors.getJobStatus(
            inspectorStore,
            EInspectorActions.GET_INDEX_OF_TASKS
        );
    },
    jobToGetChecklists(inspectorStore: IInspectorStore) {
        return jobSelectors.getJobStatus(
            inspectorStore,
            EInspectorActions.GET_CHECKLISTS
        );
    },
	
};
export default inspectorSelectors;
